export const SET_INDI_CHALLENGES = 'SET_INDI_CHALLENGES';
export const SET_INDI_CHALLENGE_PARITICIPANTS = 'SET_INDI_CHALLENGE_PARITICIPANTS';
